export const itemsPerPage = 25;
export const itemsRange = [10, 25, 100];
